"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneNumberInput = void 0;
var React = require("react");
var max_1 = require("react-phone-number-input/max");
require("react-phone-number-input/style.css");
require("./PhoneNumberInput.css");
var player_textbox_1 = require("player-textbox");
var getCountryISO3 = require("country-iso-2-to-3");
var PhoneNumberInput = (function (_super) {
    __extends(PhoneNumberInput, _super);
    function PhoneNumberInput(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.handleTextBoxChange = function (value) {
            _this.setState({
                phoneValue: value,
                errorMessage: '',
            }, function () {
                _this.notifyParentAboutChange({
                    phoneNumber: _this.state.phoneValue || '',
                    phoneNumberValid: undefined,
                    countryCode: undefined,
                });
            });
        };
        _this.handlePhoneChange = function (value) {
            var isValid = false;
            var countryCode;
            var phoneNumber = '';
            if (value) {
                isValid = _this.validatePhoneNumber(value);
                try {
                    var parsed = max_1.parsePhoneNumber(value);
                    if (parsed) {
                        countryCode = parseInt(parsed.countryCallingCode);
                        phoneNumber = parsed.nationalNumber;
                    }
                    else {
                        phoneNumber = value.replace(/^\+\d+/, '');
                        var match = value.match(/^\+(\d+)/);
                        if (match) {
                            countryCode = parseInt(match[1]);
                        }
                    }
                }
                catch (error) {
                    phoneNumber = value.replace(/^\+\d+/, '');
                    var match = value.match(/^\+(\d+)/);
                    if (match) {
                        countryCode = parseInt(match[1]);
                    }
                }
            }
            else {
                if (_this.state.selectedCountry) {
                    try {
                        countryCode = parseInt(max_1.getCountryCallingCode(_this.state.selectedCountry));
                    }
                    catch (error) {
                        console.warn('Error getting calling code for selected country:', error);
                    }
                }
            }
            _this.setState({
                phoneValue: value,
                errorMessage: '',
                phoneNumberValid: isValid,
            }, function () {
                _this.notifyParentAboutChange({
                    phoneNumber: phoneNumber,
                    phoneNumberValid: _this.state.phoneNumberValid,
                    countryCode: countryCode,
                });
            });
        };
        _this.handleCountryChange = function (country) {
            if (!country) {
                console.warn('handleCountryChange received undefined country, keeping current country:', _this.state.selectedCountry);
                return;
            }
            var newPhoneValue = _this.state.phoneValue;
            if (_this.state.phoneValue) {
                try {
                    var nationalNumber = '';
                    try {
                        var parsed = max_1.parsePhoneNumber(_this.state.phoneValue);
                        if (parsed && parsed.nationalNumber) {
                            nationalNumber = parsed.nationalNumber;
                        }
                        else {
                            nationalNumber = _this.state.phoneValue.replace(/^\+\d+\s?/, '');
                        }
                    }
                    catch (_a) {
                        nationalNumber = _this.state.phoneValue.replace(/^\+\d+\s?/, '');
                    }
                    if (nationalNumber) {
                        var newCountryCallingCode = max_1.getCountryCallingCode(country);
                        newPhoneValue = "+" + newCountryCallingCode + nationalNumber;
                    }
                }
                catch (error) {
                    console.error('Error in handleCountryChange:', error);
                    newPhoneValue = _this.state.phoneValue;
                }
            }
            _this.setState({
                selectedCountry: country,
            }, function () {
                if (newPhoneValue) {
                    _this.handlePhoneChange(newPhoneValue);
                }
            });
        };
        _this.handleOnBlur = function () {
            if (_this.props.onBlur) {
                _this.props.onBlur();
            }
        };
        _this.handlePhoneChange = _this.handlePhoneChange.bind(_this);
        _this.handleCountryChange = _this.handleCountryChange.bind(_this);
        _this.handleTextBoxChange = _this.handleTextBoxChange.bind(_this);
        _this.handleOnBlur = _this.handleOnBlur.bind(_this);
        _this.getInitialPhoneValue = _this.getInitialPhoneValue.bind(_this);
        _this.getInitialCountry = _this.getInitialCountry.bind(_this);
        _this.getCountryFromCallingCode = _this.getCountryFromCallingCode.bind(_this);
        _this.notifyParentAboutChange = _this.notifyParentAboutChange.bind(_this);
        _this.validatePhoneNumber = _this.validatePhoneNumber.bind(_this);
        _this.setupCountrySelectListener = _this.setupCountrySelectListener.bind(_this);
        _this.initializeLocalizedLabels = _this.initializeLocalizedLabels.bind(_this);
        _this.isPhoneCountryCodeSelectorVisible = !!props.isPhoneCountryCodeSelectorVisible;
        _this.countryLocalizations = props.countryLocalizations;
        _this.containerRef = React.createRef();
        var initialPhoneValue = _this.getInitialPhoneValue(props.value);
        var initialCountry = _this.getInitialCountry(initialPhoneValue, (_a = props.value) === null || _a === void 0 ? void 0 : _a.countryCode);
        var localizedLabels = _this.initializeLocalizedLabels(props.countryLocalizations);
        _this.state = {
            phoneValue: initialPhoneValue,
            selectedCountry: initialCountry,
            errorMessage: props.errorMessage,
            phoneNumberValid: !!!props.errorMessage && (initialPhoneValue ? _this.validatePhoneNumber(initialPhoneValue) : false),
            localizedLabels: localizedLabels,
        };
        return _this;
    }
    PhoneNumberInput.prototype.initializeLocalizedLabels = function (countryLocalizations) {
        if (!countryLocalizations || countryLocalizations.length === 0) {
            return undefined;
        }
        var localizationMap = new Map();
        countryLocalizations.forEach(function (x) {
            localizationMap.set(x.iso3.toUpperCase(), x);
        });
        var localizedLabels = {};
        var countries = max_1.getCountries();
        countries.forEach(function (countryCode) {
            try {
                var iso3 = getCountryISO3(countryCode);
                if (iso3) {
                    var localization = localizationMap.get(iso3.toUpperCase());
                    if (localization && localization.name) {
                        localizedLabels[countryCode] = localization.name;
                    }
                }
            }
            catch (error) {
            }
        });
        return Object.keys(localizedLabels).length > 0 ? localizedLabels : undefined;
    };
    PhoneNumberInput.prototype.componentDidMount = function () {
        if (this.isPhoneCountryCodeSelectorVisible) {
            this.setupCountrySelectListener();
        }
    };
    PhoneNumberInput.prototype.componentDidUpdate = function (prevProps) {
        var _a, _b;
        if (this.props.countryLocalizations !== prevProps.countryLocalizations) {
            var localizedLabels = this.initializeLocalizedLabels(this.props.countryLocalizations);
            this.setState({
                localizedLabels: localizedLabels,
            });
        }
        if (!prevProps.value ||
            (this.props.value &&
                (this.props.value.phoneNumber !== prevProps.value.phoneNumber || this.props.value.countryCode !== prevProps.value.countryCode))) {
            if (this.isPhoneCountryCodeSelectorVisible) {
                var newPhoneValue = this.getInitialPhoneValue(this.props.value);
                var newCountry = this.getInitialCountry(newPhoneValue, (_a = this.props.value) === null || _a === void 0 ? void 0 : _a.countryCode);
                this.setState({
                    phoneValue: newPhoneValue,
                    selectedCountry: newCountry,
                    phoneNumberValid: newPhoneValue ? this.validatePhoneNumber(newPhoneValue) : false,
                });
            }
            else {
                var phoneNumber = ((_b = this.props.value) === null || _b === void 0 ? void 0 : _b.phoneNumber) || '';
                this.setState({
                    phoneValue: phoneNumber,
                });
            }
        }
        if (this.props.errorMessage !== prevProps.errorMessage) {
            this.setState({
                errorMessage: this.props.errorMessage,
            });
        }
        if (this.isPhoneCountryCodeSelectorVisible) {
            this.setupCountrySelectListener();
        }
    };
    PhoneNumberInput.prototype.setupCountrySelectListener = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.containerRef.current) {
                var selectElement_1 = _this.containerRef.current.querySelector('.PhoneInputCountrySelect');
                if (selectElement_1 && !selectElement_1.hasAttribute('data-listener-added')) {
                    selectElement_1.setAttribute('data-listener-added', 'true');
                    selectElement_1.addEventListener('keydown', function (event) {
                        if (event.key === 'ArrowUp' || event.key === 'ArrowDown' || event.key === ' ') {
                            event.preventDefault();
                            try {
                                if (typeof selectElement_1.showPicker === 'function') {
                                    selectElement_1.showPicker();
                                }
                                else {
                                    var clickEvent = new MouseEvent('mousedown', {
                                        bubbles: true,
                                        cancelable: true,
                                        view: window,
                                    });
                                    selectElement_1.dispatchEvent(clickEvent);
                                }
                            }
                            catch (error) {
                                selectElement_1.focus();
                            }
                        }
                    });
                    selectElement_1.addEventListener('keydown', function (event) {
                        if (event.key === 'Enter') {
                            event.preventDefault();
                            try {
                                if (typeof selectElement_1.showPicker === 'function') {
                                    selectElement_1.showPicker();
                                }
                                else {
                                    selectElement_1.click();
                                }
                            }
                            catch (error) {
                                selectElement_1.focus();
                            }
                        }
                    });
                }
            }
        }, 100);
    };
    PhoneNumberInput.prototype.getInitialPhoneValue = function (value, defaultCountry) {
        if (defaultCountry === void 0) { defaultCountry = 'US'; }
        if (!(value === null || value === void 0 ? void 0 : value.phoneNumber)) {
            return undefined;
        }
        if (value.phoneNumber.startsWith('+')) {
            return value.phoneNumber;
        }
        if (!value.countryCode) {
            try {
                var defaultCountryCode = max_1.getCountryCallingCode(defaultCountry);
                var cleanPhoneNumber = value.phoneNumber.replace(/\D/g, '');
                return "+" + defaultCountryCode + cleanPhoneNumber;
            }
            catch (error) {
                console.warn('Error getting default country code:', error);
                return value.phoneNumber;
            }
        }
        if (value.countryCode && value.phoneNumber) {
            return "+" + value.countryCode + value.phoneNumber;
        }
        return value.phoneNumber;
    };
    PhoneNumberInput.prototype.getCountryFromCallingCode = function (callingCode) {
        var _a;
        try {
            var countries = max_1.getCountries();
            var callingCodeStr_1 = callingCode.toString();
            if ((_a = this.state) === null || _a === void 0 ? void 0 : _a.selectedCountry) {
                try {
                    if (max_1.getCountryCallingCode(this.state.selectedCountry) === callingCodeStr_1) {
                        return this.state.selectedCountry;
                    }
                }
                catch (_b) {
                    console.warn('Error in getCountryFromCallingCode for country code: ', callingCode);
                }
            }
            var matchingCountry = countries.find(function (country) {
                try {
                    return max_1.getCountryCallingCode(country) === callingCodeStr_1;
                }
                catch (_a) {
                    return false;
                }
            });
            return matchingCountry;
        }
        catch (error) {
            return undefined;
        }
    };
    PhoneNumberInput.prototype.getInitialCountry = function (phoneValue, countryCode) {
        if (phoneValue) {
            try {
                var parsed = max_1.parsePhoneNumber(phoneValue);
                if (parsed === null || parsed === void 0 ? void 0 : parsed.country) {
                    return parsed.country;
                }
            }
            catch (error) {
                console.warn('Error parsing phone number for country:', error);
            }
        }
        if (countryCode) {
            var country = this.getCountryFromCallingCode(countryCode);
            if (country) {
                return country;
            }
        }
        try {
            var language = navigator.language;
            var countryFromLocale = language.split('-')[1];
            if (countryFromLocale && countryFromLocale.length === 2) {
                var upperCountry = countryFromLocale.toUpperCase();
                var countries = max_1.getCountries();
                if (countries.indexOf(upperCountry) !== -1) {
                    return upperCountry;
                }
            }
        }
        catch (error) {
            console.warn('Error getting country from locale:', error);
        }
        return 'US';
    };
    PhoneNumberInput.prototype.validatePhoneNumber = function (phoneValue) {
        if (!phoneValue) {
            return false;
        }
        try {
            return max_1.isValidPhoneNumber(phoneValue);
        }
        catch (error) {
            console.warn('Error validating phone number:', error);
            return false;
        }
    };
    PhoneNumberInput.prototype.notifyParentAboutChange = function (value) {
        if (this.props.onChange) {
            this.props.onChange(value, this.props.tag);
        }
    };
    PhoneNumberInput.prototype.renderAsTextbox = function (props) {
        return React.createElement(player_textbox_1.Textbox, __assign(__assign({}, props), { value: this.state.phoneValue || '', errorMessage: this.state.errorMessage, onChange: this.handleTextBoxChange, onBlur: this.handleOnBlur }));
    };
    PhoneNumberInput.prototype.renderWithCountryCodeSelector = function (props) {
        var id = props.id || props.tag;
        return React.createElement('div', {
            'data-tag': props.tag,
            className: "p-textbox form-row " + (props.isRequired ? 'is-required' : ''),
            ref: this.containerRef,
        }, React.createElement('div', null, props.showLabel &&
            React.createElement('div', null, React.createElement('label', {
                htmlFor: id,
                className: 'with-label p-t-grey40 p-m-v-sm',
            }, props.label), props.isRequired &&
                React.createElement('span', {
                    className: 'p-t-error50',
                }, '*')), React.createElement('div', null, React.createElement(max_1.default, {
            id: id,
            value: this.state.phoneValue,
            onChange: this.handlePhoneChange,
            onCountryChange: this.handleCountryChange,
            onBlur: this.handleOnBlur,
            defaultCountry: this.state.selectedCountry,
            labels: this.state.localizedLabels,
            className: "phone-number-input " + (this.state.errorMessage ? 'is-invalid p-b-error p-bc-error50' : ''),
            numberInputProps: {
                className: 'p-textbox-input p-bc-grey40 p-bg-hv-white p-bc-f-blue50 row-1',
                'aria-label': "Phone number input box",
                autoComplete: 'tel',
            },
            countrySelectProps: {
                className: 'country-select',
                'aria-label': "Country selector",
            },
            international: true,
            withCountryCallingCode: true,
            displayInitialValueAsLocalNumber: false,
            smartCaret: true,
            countryCallingCodeEditable: false,
            focusInputOnCountrySelection: true,
        }), this.state.errorMessage &&
            React.createElement('span', {
                className: 'error p-t-error50 p-m-t-sm',
                role: 'alert',
            }, this.state.errorMessage))));
    };
    PhoneNumberInput.prototype.render = function () {
        var _a = this.props, key = _a.key, value = _a.value, errorMessage = _a.errorMessage, onChange = _a.onChange, onBlur = _a.onBlur, props = __rest(_a, ["key", "value", "errorMessage", "onChange", "onBlur"]);
        return React.createElement('div', { key: key }, this.isPhoneCountryCodeSelectorVisible ? this.renderWithCountryCodeSelector(props) : this.renderAsTextbox(props));
    };
    PhoneNumberInput.defaultProps = {
        onChange: function () { },
        onBlur: function () { },
    };
    return PhoneNumberInput;
}(React.Component));
exports.PhoneNumberInput = PhoneNumberInput;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["PhoneNumberInput"] = undefined;


//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/PhoneNumberInput/PhoneNumberInput.js
// module id = 272
// module chunks = 0 1